"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFullscreen = isFullscreen;
exports.enterFullscreen = enterFullscreen;
exports.exitFullscreen = exitFullscreen;
exports.toggleFullscreen = toggleFullscreen;
var mobile_1 = require("@caddigital/sok-ui/lib/utils/mobile");
require("./fullscreen.scss");
function isFullscreen(element) {
    return !!((element &&
        element.classList &&
        element.classList.contains('mobile-safari-fullscreen')) ||
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement);
}
function enterFullscreen(element) {
    var onFullScreenChange = function () {
        if (element.classList.contains('sok-fullscreen')) {
            element.classList.remove('sok-fullscreen');
            exitFullscreen(element);
            return;
        }
        element.classList.add('sok-fullscreen');
    };
    if (document.onfullscreenchange === null) {
        document.onfullscreenchange = onFullScreenChange;
    }
    else if (document.onmsfullscreenchange === null) {
        ;
        document.onmsfullscreenchange = onFullScreenChange;
    }
    else if (document.onmozfullscreenchange === null) {
        ;
        document.onmozfullscreenchange = onFullScreenChange;
    }
    else if (document.onwebkitfullscreenchange === null) {
        ;
        document.onwebkitfullscreenchange = onFullScreenChange;
    }
    if (mobile_1.isMobileSafari) {
        element.classList.add('mobile-safari-fullscreen');
    }
    else if (element.requestFullscreen) {
        element.requestFullscreen(); // tslint:disable-line
    }
    else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen(); // tslint:disable-line
    }
    else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen(); // tslint:disable-line
    }
    else if (element.msRequestFullscreen) {
        element.msRequestFullscreen(); // tslint:disable-line
    }
}
function exitFullscreen(element) {
    if (mobile_1.isMobileSafari) {
        element.classList.remove('mobile-safari-fullscreen');
    }
    else if (document.exitFullscreen) {
        document.exitFullscreen(); // tslint:disable-line
    }
    else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen(); // tslint:disable-line
    }
    else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen(); // tslint:disable-line
    }
    else if (document.msExitFullscreen) {
        document.msExitFullscreen(); // tslint:disable-line
    }
}
function toggleFullscreen(element) {
    if (isFullscreen(element)) {
        exitFullscreen(element);
    }
    else {
        enterFullscreen(element);
    }
}
